import { useTranslation } from "react-i18next";
import { Col, Row } from "react-grid-system";
import type { InvoiceAssessmentRuleModel } from "../../../models/InvoiceAssessment";
import CircleIcon from "../../atoms/CircleIcon";
import { HorizontalSpacer } from "../../atoms/Spacers";
import TextField from "../../atoms/inputs/TextField";
import BodySmall from "../../atoms/typography/BodySmall";
import Small from "../../atoms/typography/Small";

interface Props {
  rules: InvoiceAssessmentRuleModel[];
  reasons: Record<string, string>;
  onChange: (invoiceAssessmentRuleId: string, reason: string) => void;
  columns?: 1 | 2;
}

const RuleOverrideReasonFields: React.FC<Props> = ({
  rules,
  reasons,
  onChange,
  columns = 2,
}) => {
  const { t } = useTranslation();

  return (
    <Row align="start" component="ul" style={{ listStyle: "none", padding: 0 }}>
      {rules.map((rule) => (
        <Col
          lg={columns === 2 ? 6 : 12}
          key={rule.invoiceAssessmentRuleId}
          component="li"
        >
          <div style={{ display: "flex", gap: 8 }}>
            <CircleIcon type="failed" />
            <div style={{ flex: 1 }}>
              <BodySmall fontweight="500">{rule.ruleName}</BodySmall>
              <Small fontweight={400}>{rule.message}</Small>
              <HorizontalSpacer spacing={0.5} />
              <TextField
                label={t("invoiceAssessment.reasonForApprovingDespiteRule")}
                value={reasons[rule.invoiceAssessmentRuleId] ?? ""}
                onChange={(value) =>
                  onChange(rule.invoiceAssessmentRuleId, value)
                }
                fullWidth
              />
            </div>
          </div>
          <HorizontalSpacer spacing={1.5} />
        </Col>
      ))}
    </Row>
  );
};

export default RuleOverrideReasonFields;
